import { EditorProviderButtonSettings } from '../EditorProviderButtonSettings';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorGitlabButton = customizeCraftJsComponent(EditorButton, {
	name: 'Gitlab Button',
	props: {
		children: '',
		startIcon: 'gitlab',
		shape: 'square',
		variant: 'outline',
		'data-descope-provider': 'gitlab',
		startIconColorText: false,
		formNoValidate: true,
		'data-type': 'social'
	},
	related: {
		settings: EditorProviderButtonSettings
	},
	custom: {
		subType: 'social'
	}
});
